module.exports = __webpack_public_path__ + "img/sertifikat-pemenang.059e3775.png";